<template>
  <v-app>
    <app-menu v-if="isAuthenticated"/>
    <app-toolbar v-if="isAuthenticated"/>

    <v-main :class="{'is-mobile': $vuetify.breakpoint.mobile}">

      <v-container fluid class="pa-0">
          <router-view></router-view>
      </v-container>
    </v-main>

  </v-app>
</template>

<script>

import GlobalSearch from "./components/app/GlobalSearch";
import {mapActions, mapGetters, mapState} from "vuex";
import AppMenu from "./components/app/AppMenu";
import AppToolbar from "./components/app/AppToolbar";

export default {
  name: 'App',
  components: {AppToolbar, AppMenu,  GlobalSearch},
  computed: {
    ...mapState('route', ['name']),
    ...mapGetters('auth',['isAuthenticated'])
  },
  watch: {
    isAuthenticated: {
      async handler(v) {
        if(!v) {
          this.$router.replace({name: await this.getDefaultLoginPage()});
        } else {
          this.$router.replace({
            name: await this.getDefaultHomePage()
          });
        }
      }
    }
  },
  methods: {
    ...mapActions('menu',['toggle']),
    ...mapActions('auth',['getDefaultLoginPage','getDefaultHomePage'])
  },
  mounted() {
  },
  created() {
    // window.addEventListener("load", function() { window. scrollTo(0, 0); });
    // document.addEventListener("touchmove", function(e) { e.preventDefault() });
  }
};
</script>

<style lang="scss">

.v-main.is-mobile {
  overflow: auto;
}


.swal2-container {

  &.break {
    #swal2-content {
      overflow: hidden;
    }
  }

  .swal2-modal {
    border: 1px solid #CCCCCC;
    font-family: 'Roboto', sans-serif;
    max-width: 60%;
    padding: 0px;

    .subtitle {
      width: 100%;
    }
  }

  .swal2-content {
    padding: 5px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swal2-icon {
    transform: scale(0.8) !important; /* Redu��o extrema proporcional */
  }

  .swal2-title {
    padding: 0px;
  }
  .swal2-header {
    border-bottom: 1px solid #dedede;
  }

  .swal2-actions {
    margin-top: 0;
    padding: 10px 10px;
    border-top: 1px solid #dedede;
    display: flex;
    justify-content: space-between;
  }
}

.v-dialog.action-sheet {
  bottom: 0;
  position: fixed;
  margin-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  .v-card {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.v-main__wrap {
  background-color: #F0F2F5;
  display: flex;

  > .container {
    flex: 1;
    display: flex;

    > .page {
      flex: 1;
    }
  }

}

.titular {
  color: #2A80B9;
  font-weight: bold;
}
.dependente {
  color: orange;
  font-weight: bold;
}

.no-spinner input::-webkit-outer-spin-button,
.no-spinner input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner input[type="number"] {
  -moz-appearance: textfield;
}
</style>
